export default "__VITE_ASSET__DKlfCtZv__"